<template>
  <div>
    <select
      @change="$emit('input', vmodel)"
      class="form-control"
      :class="{
        'is-invalid': hasErrors,
        disabled: disabled
      }"
      v-model="vmodel"
      name="name"
    >
      <option v-if="nullable" :key="null" :value="null">
        {{ attribute.nullValue }}
      </option>
      <option
        v-for="(item, index) in attribute.items"
        :key="index"
        :value="item.value"
      >
        {{ item.text }}
      </option>
    </select>
    <div
      v-if="hasErrors"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [],
      vmodel: null
    };
  },
  created() {
    if (this.value) {
      this.vmodel = this.value;
    }
  },
  props: ["attribute", "value", "disabled"],
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    nullable() {
      return this.attribute.nullValue !== undefined;
    }
  }
};
</script>
